import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaginationInfiniteScrollComponent, PaginationScrollingComponent } from './components';

@NgModule({
  declarations: [PaginationScrollingComponent, PaginationInfiniteScrollComponent],
  imports: [CommonModule],
  exports: [PaginationScrollingComponent, PaginationInfiniteScrollComponent],
})
export class PaginationModule {}
